import { render, staticRenderFns } from "./spreadsheet.vue?vue&type=template&id=078c3c2e"
import script from "./spreadsheet.vue?vue&type=script&lang=js"
export * from "./spreadsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports